function feedback(){
  var trialType = columnForTrial('type', trialRow);
  var isCorrectAnswer = false;
  var response = responses[responses.length-1];
  var timedOut = false;

  if(trialType == 'test'){
    isCorrectAnswer = correct[correct.length-1] == "1";
    timedOut = timeout[timeout.length-1] == "1";
  }
  else if(trialType == 'practice'){
    //last response in the responses array is not from this trial as practice trials are not recorded
    response = '';
    isCorrectAnswer = correctPractice[correctPractice.length-1] == "1";
    timedOut = timeoutPractice[timeoutPractice.length-1] == "1";
  }

  var lastResponse = window.allResponses[window.allResponses.length - 1];
  var lastRT = window.allRTs[window.allRTs.length - 1];
  var lastCorrect = window.allCorrects[window.allCorrects.length - 1];

  var feedbackString = replaceVariables(columnForTrial('feedback', trialRow),lastResponse, lastRT, lastCorrect);
  var feedbackCorrectString = replaceVariables(columnForTrial('feedbackCorrect', trialRow),lastResponse, lastRT, lastCorrect);
  var feedbackIncorrectString = replaceVariables(columnForTrial('feedbackIncorrect', trialRow),lastResponse, lastRT, lastCorrect);

  var feedbackObject = getFeedbackObject(
        feedbackString,
        feedbackCorrectString,
        feedbackIncorrectString
  );

  console.log('feedback object', feedbackObject);

  console.log('feedback key', columnForTrial('key', trialRow));

  if (!feedbackObject && feedbackString == 'na') {
      //no feedback to dislay or correct answer, skipping
      main();
      return;
  }

  if (timedOut && feedbackObject['timeout']) {
    displayFeedback(feedbackObject['timeout']);
  }
  // else if(columnForTrial('key', trialRow)=="na"){
  //   //no correct answer and didn't timeout
  //   main();
  //   return;
  // }
  else if (feedbackObject[lastResponse] && !timedOut){
    displayFeedback(feedbackObject[lastResponse]);
  }
  else if (feedbackObject['correct'] && isCorrectAnswer && !timedOut){
    displayFeedback(feedbackObject['correct']);
  }
  else if (feedbackObject['incorrect'] && !isCorrectAnswer && !timedOut){
    displayFeedback(feedbackObject['incorrect']);
  }
  else if(feedbackObject['other'] && !timedOut){
    displayFeedback(feedbackObject['other']);
  }
  else{
    //no feedback to display for our response, skipping.
    main();
    return;
  }

  feedbackScreen = 1;

  var feedbackTime = columnForTrial('feedbackTime', trialRow);

  if (feedbackTime=="na") {
    showOneButtonStandard(textScreens['pdetails'][language][10]);
  }
  else {
    //self-advancing for feedback
    eventTimeOutFeedback = setTimeout(endTrial, feedbackTime, true);
  }
}

function getFeedbackObject(feedbackString, correctString, incorrectString){
  var feedbackObject = {}
  var foundValues = false;

  if (feedbackString && feedbackString != 'na') {
    //Split the feedback options (correct:correct feedback;incorrect: incorrect feedback)
    var feedbackOptions = feedbackString.split(';');
    for(var index in feedbackOptions){
      //split the key value of the option (correct: correct feedback -> ['correct','correct feedback'])
      var option = feedbackOptions[index].split(/:(.+)/);
      console.log('feedback option', option);
      if(option[0] && option[1]){
        feedbackObject[option[0].trim()] = option[1].trim();
        foundValues = true;
      }
      else if(option[0]){
        feedbackObject['other'] = option[0];
        foundValues = true;
      }
    }
  }

  if (correctString && correctString != 'na') {
    feedbackObject.correct = correctString;
    foundValues = true;
  }

  if (incorrectString && incorrectString != 'na') {
    feedbackObject.incorrect = incorrectString;
    foundValues = true;
  }

  return foundValues ? feedbackObject : null;
}

function displayFeedback(feedback){
  const optionString = columnForTrial('feedbackOptions', trialRow);
  var isCentered = false, sameScreen = false;
  if(optionString != "na"){
    var options = optionString.split(';');
    for(var i = 0; i < options.length; i++){
      var currentOption = options[i].trim().toLowerCase();

      if(currentOption == 'center'){
        isCentered = true;
      }

      else if(currentOption == 'samescreen'){
        sameScreen = true;
      }
    }
  }

  if(sameScreen === false){
    hideAll();
  }

  const colorOption = listTrialColorOptions[trialRow];
  //change color to default
  if (textColor_setup!="na" && !(colorOption && colorOption.color)) {
    document.body.style.color = "#" + textColor_setup;
    document.documentElement.style.color = "#" + textColor_setup;
  }

  if(colorOption && colorOption.color){
    document.getElementById('content').style.color = colorOption.color;
  }
 
  if(colorOption && colorOption.feedback){
    document.getElementById('content').style.color = colorOption.feedback;
  }

  displayText("title",listArrays[allColumns.indexOf('title')][trialRow]);
  displayText("title",listArrays[allColumns.indexOf('head')][trialRow]);
  displayText("content", feedback, '', null, isCentered);
}

function cleanFeedback(){
  document.getElementById('content').style.color = '';
}

function isFeedbackSameScreen(){
  const feedbackOptions = window.columnForTrial('feedbackOptions', trialRow);
  if (!feedbackOptions) {
    return false;
  }
  return feedbackOptions.indexOf('sameScreen') >=0;
}